import { matchPath, Location } from 'react-router';

import { NavigationBarItem } from '@/components/NavigationBar/types';
import {
  adminToolPaths,
  adminToolTabs,
  pathNames
} from '@/constants/adminTool';

const adminBreadcrumb = { label: 'Admin', path: '' };

export const addIdToBreadcrumb = () => {
  const customName = pathNames.find(route =>
    matchPath(route.path, location.pathname)
  );

  if (customName?.name) {
    return { label: customName.name, path: '' };
  }
  return null;
};

export const createBreadcrumb = (location: Location) => {
  const pathSegments = location.pathname.split('/');

  const tabSegment = pathSegments[2];

  const breadcrumbArray = [
    adminBreadcrumb,
    {
      label: adminToolTabs.find(tab => tab.id === tabSegment)?.label || '',
      path: `${adminToolPaths.root}/${tabSegment}`
    }
  ];

  const idToBreadcrumb = addIdToBreadcrumb();
  if (idToBreadcrumb) {
    breadcrumbArray.push(idToBreadcrumb);
  }

  return { tabSegment, breadcrumbArray };
};

export const isCustomBreadcrumbForPath = (
  customBreadcrumb: Partial<NavigationBarItem>,
  pathname: string
): boolean => {
  if (!customBreadcrumb.path) {
    return false;
  }
  const [pathWithoutQuery] = customBreadcrumb.path.split('?');
  return pathname.toLowerCase() === pathWithoutQuery.toLowerCase();
};
